// extracted by mini-css-extract-plugin
module.exports = {"Logos":"Logos_Logos__1jwpE","Logo":"Logos_Logo__1J5ja"};